import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";

export interface IPostal {
  id: number;
  postal_code: string;
  name: string;
  created_at: Date;
  updated_at: Date;
}

export class Postal extends AbstractJSONModel implements IPostal {
  public id = 0;
  public name = "";
  public postal_code = "";
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();

  equals(other: IPostal): boolean {
    return other.id === this.id;
  }
}
